<div class="cfo-report" *ngIf="report; else fallbackTpl">

  <!-- Header -->
  <div class="cfo-report__header">
    <div class="cfo-report__titles">
      <h4 class="cfo-report__title">{{ report.title }}</h4>
      <span class="cfo-report__subtitle" *ngIf="report.subtitle">{{ report.subtitle }}</span>
    </div>
    <div class="cfo-report__actions">
      <button class="cfo-report__btn cfo-report__btn--csv"
              type="button"
              title="Descargar CSV"
              (click)="downloadCsv()">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="7 10 12 15 17 10"></polyline>
          <line x1="12" y1="15" x2="12" y2="3"></line>
        </svg>
        CSV
      </button>
      <button class="cfo-report__btn cfo-report__btn--pdf"
              type="button"
              title="Descargar PDF"
              [disabled]="downloading"
              (click)="downloadPdf()">
        <span *ngIf="downloading" class="cfo-report__spinner"></span>
        <svg *ngIf="!downloading" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
        </svg>
        {{ downloading ? 'Generando…' : 'PDF' }}
      </button>
    </div>
  </div>

  <!-- Table -->
  <div class="cfo-report__table-wrap">
    <table class="cfo-report__table">
      <thead>
        <tr>
          <th *ngFor="let col of report.columns">{{ col }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of report.rows">
          <td *ngFor="let cell of row">{{ cell }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Summary -->
  <p class="cfo-report__summary" *ngIf="report.summary">{{ report.summary }}</p>

</div>

<ng-template #fallbackTpl>
  <pre class="cfo-report__raw" *ngIf="fallbackRaw">{{ fallbackRaw }}</pre>
</ng-template>
